import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import TypographySection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/TypographySection'
import BackgroundSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/BackgroundSection'
import BorderSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/BorderSection'
import SizeSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/SizeSection'

export default function Styling(props: {
  control: UseFormMethods['control']
  watch: UseFormMethods['watch']
  button: NavButtonWithSize
}) {
  const {control, button, watch} = props

  return (
    <>
      <TypographySection
        button={button}
        control={control}
        storageKey="mainNav.config.styling.typography"
      />
      <BackgroundSection
        button={button}
        control={control}
        watch={watch}
        storageKey="mainNav.config.styling.background"
      />
      <SizeSection
        button={button}
        control={control}
        storageKey="mainNav.config.styling.size"
      />
      <BorderSection
        button={button}
        control={control}
        storageKey="mainNav.config.styling.border"
      />
    </>
  )
}
